import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { RefreshMethod } from '../api/inventoryResource.model';

export const RefreshMethodSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.RefreshMethod}-${RefreshMethod.fullScan}`,
    value: RefreshMethod.fullScan,
    displayName: 'Full Scan',
    withoutBeautifyDisplayName: true,
    categoryName: FilterTypesEnum.RefreshMethod.toString(),
    filterType: FilterTypesEnum.RefreshMethod,
  },
  {
    id: `${FilterTypesEnum.RefreshMethod}-${RefreshMethod.eventDriven}`,
    value: RefreshMethod.eventDriven,
    displayName: 'Lightning',
    withoutBeautifyDisplayName: true,
    categoryName: FilterTypesEnum.RefreshMethod.toString(),
    filterType: FilterTypesEnum.RefreshMethod,
  },
];
